import React, { useContext, useState } from 'react';
import { IconButton, Menu, MenuItem, Box } from '@mui/material';
import { ThemeContext } from 'styled-components';

/**
 * Renders the same triple-dot row menu as TransactionsModel. Shown only for statements the current user owns.
 * Menu shows "Edit"; clicking Edit calls onEdit(statementId).
 */
const DefaultStatementRowMenu = ({ statementId, ownedStatementIds, onEdit }) => {
    const theme = useContext(ThemeContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const isOwned = Array.isArray(ownedStatementIds) && ownedStatementIds.includes(String(statementId));

    if (!isOwned) return null;

    const handleMenuClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleMenuClose = () => setAnchorEl(null);

    const handleEdit = () => {
        handleMenuClose();
        onEdit?.(statementId);
    };

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                <IconButton
                    size="small"
                    aria-label="Statement options"
                    aria-controls={open ? 'statement-row-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleMenuClick}
                    sx={{
                        color: 'inherit',
                        padding: '8px',
                        minWidth: '40px',
                        minHeight: '40px',
                        '&:hover': { backgroundColor: theme.colors?.overlayHover },
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, alignItems: 'center', justifyContent: 'center', py: 0.5 }}>
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', border: `1.5px solid ${theme.colors?.text || 'currentColor'}` }} />
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', border: `1.5px solid ${theme.colors?.text || 'currentColor'}` }} />
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', border: `1.5px solid ${theme.colors?.text || 'currentColor'}` }} />
                    </Box>
                </IconButton>
            </Box>
            <Menu
                id="statement-row-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        backgroundColor: theme?.colors?.backgroundPrimary,
                        color: theme?.colors?.text,
                    },
                }}
            >
                <MenuItem onClick={handleEdit}>Edit</MenuItem>
            </Menu>
        </>
    );
};

export default DefaultStatementRowMenu;
